import { createOrangeKitConnector } from "../connector";
import { OrangeKitBitcoinProvider } from "../bitcoin-wallet-provider";
import icon from "./icon";
import XverseInjectedProvider from "./provider";
export default function getOrangeKitXverseConnector({ rpcUrl, chainId, relayApiKey, }) {
    const xverseProvider = window?.XverseProviders?.BitcoinProvider;
    const injectedProvider = xverseProvider
        ? new XverseInjectedProvider()
        : undefined;
    const bitcoinWalletProvider = new OrangeKitBitcoinProvider(injectedProvider);
    return () => createOrangeKitConnector("orangekit-xverse", "Xverse", icon, rpcUrl, chainId, bitcoinWalletProvider, relayApiKey);
}
//# sourceMappingURL=connector.js.map